import * as React from 'react';

const ArrowRight = () => (
  <svg
    width="16"
    height="16"
    fill="none"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g fill="none" fillRule="evenodd">
      <rect width="24" height="24"></rect>
      <path d="M9 18l6-6-6-6z" fill="currentColor"></path>
    </g>
  </svg>
);

export default ArrowRight;
